module.exports = __webpack_public_path__ + "img/collection-weddingRingsTwoColors.07d9abc.webp";